import {ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {Router} from '@angular/router';
import {debounceTime, first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {Sort} from '@angular/material/sort';
import {PayerService} from '../../Services/payer.service';
import {MatPaginator} from '@angular/material/paginator';
import {Subject} from 'rxjs';

interface PatientPagination {
    page: number;        // API uses 1-based index
    size: number;        // Page size
    currentPage: number; // MatPaginator uses 0-based index
}

@Component({
    selector: 'pm-payer-creation',
    templateUrl: './payer-creation.component.html',
    styleUrls: ['./payer-creation.component.css']
})
export class PayerCreationComponent implements OnInit {


    tableData: any = [];
    totalRecord: any;
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];
    pagination: PatientPagination = {
        page: 1,         // API uses 1-based index
        size: 10,        // Default page size
        currentPage: 0   // MatPaginator uses 0-based index
    };
    searchText: any;
    isSidebarExpanded = false;
    hidePassword = true;
    hideNewPassword = true;
    hideConfirmPassword = true;
    searchString: any = null;
    @ViewChild('resetPassword') resetPassModal!: ElementRef;
    @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
    @ViewChild('searchBox') searchValue!: ElementRef;
    private clientSub: any;
    private subject: Subject<string> = new Subject();

    constructor(private fb: FormBuilder,
                private clientServices: ClientService,
                private payerService: PayerService,
                public authService: AuthService,
                private router: Router,
                private renderer: Renderer2,
                private el: ElementRef,
                private cdr: ChangeDetectorRef,
                private ngZone: NgZone) {
        this._setSearchSubscription();
    }


    ngOnInit(): void {
        this.loadPaginationState();

        this.clientSub = this.authService.clientIdSubject.subscribe(
            (clientId: number | null) => {
            if (clientId) {
                this.pagination.page = 1;
                this.pagination.currentPage = 0;

                this._fetchData();
            }
            }
        );

        window.addEventListener('beforeunload', () => {
            sessionStorage.removeItem('payerPagination');
        });
    }
    ngOnDestroy(): void {
      this.clientSub?.unsubscribe();
    }

    ngAfterViewInit() {
        if (this.paginator) {
          this.paginator.pageIndex = this.pagination.currentPage || 0;
          this.paginator.pageSize = this.pagination.size || 10; // Restore page index
        }
    }

    // Get Payer data
   _fetchData(): void {
  const params: any = {
    page: this.pagination.page,
    size: this.pagination.size
  };

  this.payerService
    .getAllPayers(params)
    .pipe(first())
    .subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (response) {
            this.tableData = response?.content || [];
            this.totalRecord = response?.totalElements || 0;

            if (this.paginator) {
              this.paginator.pageIndex = this.pagination.currentPage;
            }

            this.cdr.detectChanges();
          } else {
            this.tableData = [];
            this.totalRecord = 0;

            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || 'No data found',
              showConfirmButton: false,
              timer: 5000
            });
          }
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.tableData = [];
          this.totalRecord = 0;

          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || 'Something went wrong',
            showConfirmButton: false,
            timer: 5000
          });
        });
      }
    );
    }

    // Delete record
    deleteEntry(payerId: any) {
        let reqData = {
            id: payerId
        };
        swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this record ?',
            icon: 'warning',
            iconColor: 'red',
            showCancelButton: true,
            confirmButtonText: 'Yes !'
        }).then((result) => {
            if (result.isConfirmed) {
                this.payerService.deletePayer(reqData).pipe(first()).subscribe(
                    (response: any) => {
                          if (response) {
                            if (this.searchString && this.searchString.trim() !== '') {
                              this.searchPayer(this.searchString);
                            } else {
                              this._fetchData();
                            }
                            swal.fire({
                                icon: 'success',
                                text: 'Record deleted successfully.',
                                showConfirmButton: false,
                                timer: 2000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: 'Something went wrong!',
                                showConfirmButton: false,
                                timer: 2000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: 'Failed to communicate with the server!',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    });
                }
        });
    }

    onKeyUp(searchTextValue: any): void {
        this.subject.next(searchTextValue);
    }

    handleKeyUp(event: KeyboardEvent) {
      const value = (event.target as HTMLInputElement).value;

      // Trigger search on Enter
      if (event.key === 'Enter') {
        this.onSearch();
        return;
      }

      // Existing debounce logic
      this.subject.next(value);
    }

    clearSearch(input: HTMLInputElement) {
      input.value = '';
      this.searchString = '';
      this.pagination.currentPage = 0;
      this.pagination.page = 1;
      this._fetchData();
    }

    private _setSearchSubscription(): void {
        this.subject.pipe(
            debounceTime(200)
        ).subscribe((searchValue: any) => {
            if (this.searchValue.nativeElement.value === '') {
                this.onSearch();
            }
        });
    }

    onSearch() {
      const inputValue = this.searchValue.nativeElement.value?.trim();

      if (inputValue) {
        this.searchString = inputValue;

        // start from first page for a new search
        this.pagination.currentPage = 0;
        this.pagination.page = 1;

        this.searchPayer(this.searchString);
      } else {
        // cleared search
        this.searchString = '';
        this.pagination.currentPage = 0;
        this.pagination.page = 1;

        this._fetchData();
      }
    }

    searchPayer(filter?: any): void {
  const params = {
    searchQuery: filter,
    page: this.pagination.page,
    size: this.pagination.size
  };

  this.payerService
    .getAllPayers(params)
    .pipe(first())
    .subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (response) {
            this.tableData = response?.content || [];
            this.totalRecord = response?.totalElements || 0;

            if (this.paginator) {
              this.paginator.pageIndex = this.pagination.currentPage;
            }

            this.cdr.detectChanges();
          } else {
            this.tableData = [];
            this.totalRecord = 0;

            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || 'No data found',
              showConfirmButton: false,
              timer: 5000
            });
          }
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.tableData = [];
          this.totalRecord = 0;

          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || 'Something went wrong',
            showConfirmButton: false,
            timer: 5000
          });
        });
      }
    );
    }

    // pagination changes
    pageChange(event: any) {
      this.pagination.currentPage = event.pageIndex;
      this.pagination.page = this.pagination.currentPage + 1; // API is 1-based
      this.pagination.size = event.pageSize;

      sessionStorage.setItem('payerPagination', JSON.stringify(this.pagination));

      // If we’re searching, keep using the search API
      if (this.searchString && this.searchString.trim() !== '') {
        this.searchPayer(this.searchString);
      } else {
        this._fetchData();
      }
    }

    loadPaginationState() {
        const storedData = sessionStorage.getItem('payerPagination');

        if (storedData) {
            this.pagination = JSON.parse(storedData);
        }
    }

    // Sort form frontend logic
    sortData(sort: Sort) {
        const data = this.tableData.slice();
        if (!sort.active || sort.direction === '') {
            this.tableData = data;
            return;
        }

        this.tableData = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name':
                    return compare(a.name, b.name, isAsc);
                case 'email':
                    return compare(a.email, b.email, isAsc);
                default:
                    return 0;
            }
        });
    }

    logout() {
        // Clear session storage during logout
        sessionStorage.removeItem('payerPagination');
        this.authService.logout();
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
